import { render, staticRenderFns } from "./MPopupUploadImg.vue?vue&type=template&id=62cc455e&"
import script from "./MPopupUploadImg.vue?vue&type=script&lang=ts&"
export * from "./MPopupUploadImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports